import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9 2v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 2v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 17v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 8h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 11V8h12v3a6 6 0 1 1-12 0v0Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Plug2";
const Plug2 = memo(themed(Icon));
export {
  Plug2
};
//# sourceMappingURL=plug-2.js.map
